import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import { StateController } from '../helpers/state/state-management/state-controller';
import topicData from '../helpers/state/topic-data';

@customElement('gpt-waiting-state')
export class GptWaitingState extends LitElement {
    @property({ type: String })
    gptQuery: string = '';

    private readonly bindTopicState = new StateController(this, topicData);

    render() {
        return html`
            <div class="gpt-waiting__wrapper">
                <h2 class="gpt-waiting__header">Getting "${this.gptQuery}" in ${topicData.topic?.default_map_center.search}</h2>
                <div class="gpt-waiting__subtext">This usually takes around 45 seconds. Take a sip of water.</div>
            </div>
        `;
    }

    static get styles() {
        return css`
            .gpt-waiting__header {
                line-height: 1.3;
                margin-bottom: 12px;
            }

            .gpt-waiting__header::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                -webkit-animation: ellipsis steps(4,end) 900ms infinite;
                animation: ellipsis steps(4,end) 900ms infinite;
                content: "...";
                width: 0px;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }

            @-webkit-keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }

            .gpt-waiting__subtext {
                margin-bottom: 10px;
                line-height: 1.3;
                color: var(--theme-input-color);
            }
        `;
    }
}
